module.exports = __webpack_public_path__ + "static/media/settingsIcon.59cb5149.png";